var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4249_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7502 15C20.7502 16.8638 20.7502 17.7956 20.4457 18.5307C20.0397 19.5108 19.261 20.2895 18.2809 20.6955C17.5458 21 16.6139 21 14.7502 21H11.7502C7.97898 21 6.09334 21 4.92177 19.8284C3.75019 18.6568 3.75021 16.7712 3.75024 12.9999L3.7503 6.99983C3.75032 4.79078 5.54112 3 7.75017 3",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7502 8.5L11.1839 12.4689C11.2253 12.8007 11.4292 13.0899 11.7364 13.2219C12.4224 13.5165 13.7072 14 14.7502 14C15.7933 14 17.0781 13.5165 17.7641 13.2219C18.0713 13.0899 18.2752 12.8007 18.3166 12.4689L18.7502 8.5M21.2502 7.5V11.2692M14.7502 4L7.75024 7L14.7502 10L21.7502 7L14.7502 4Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4249_95"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.5a4961738cca6eea0cc596ef5d9bb2bc.svg";
export { ForwardRef as ReactComponent };